// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gradient-text {
  font-size: 35px;
  font-weight: 700;
  font-family: "Graphik";
  background: linear-gradient(to right, rgb(246, 106, 75) 0%, rgb(246, 106, 75) 30%, rgb(162, 74, 231) 60%, rgb(72, 89, 243) 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-align: center;
}

.description {
  color: rgba(255, 255, 255, 0.64);
  font-family: "Graphik";
  font-size: 15px;
  text-align: center;
  margin-top: 10px;
}

@media (max-width: 768px) {
  .gradient-text {
    font-size: 28px;
  }
}
.question-box {
  margin-left: 25%;
}

.box-home {
  width: calc(15% - 10px); /* Adjusted to accommodate margin and padding */
  margin: 5px;
  padding: 10px; /* Increased padding for better spacing */
  display: flex;
  flex-direction: column;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.86);
  text-align: left;
  background-color: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 5px;
  font-size: 10px; /* Increased font size for better readability */
  gap: 5px;
}

@media (max-width: 768px) {
  .box-home {
    width: calc(25% - 10px); /* Adjusted width for smaller screens */
    font-size: 10px; /* Reduced font size for smaller screens */
  }
}
@media (max-width: 480px) {
  .box-home {
    width: calc(50% - 10px); /* Adjusted width for smaller screens */
    font-size: 8px; /* Further reduced font size for smaller screens */
  }
}
.box.selected {
  background-color: rgba(161, 0, 255, 0.2);
}

.ask-section {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.ask-text {
  color: rgba(255, 255, 255, 0.32);
  font-family: "Graphik", sans-serif;
  font-size: 12px;
  text-align: center;
  margin: 20px 0px;
}

.ask-this {
  color: rgba(255, 255, 255, 0.32);
  font-family: "Graphik", sans-serif;
  font-size: 12px;
  text-align: center;
  text-decoration: underline;
}

@media (max-width: 768px) {
  .ask-text {
    font-size: 14px;
  }
}
@media (max-width: 480px) {
  .ask-text {
    font-size: 13px;
  }
}
.box_qest {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 5px;
}

.vector-image {
  width: 15%; /* Adjust width as needed */
  margin-top: 20px;
  background-color: rgba(255, 255, 255, 0.06);
  border-radius: 5px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  padding: 3px;
}

.box-home.selected {
  border: 1px solid white;
}`, "",{"version":3,"sources":["webpack://./src/component/screens/HomeScreen.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,gIAAA;EACA,6BAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AACJ;;AAEE;EACE,gCAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AACJ;;AAGE;EACE;IACE,eAAA;EAAJ;AACF;AAGE;EACE,gBAAA;AADJ;;AAIE;EACE,uBAAA,EAAA,+CAAA;EACF,WAAA;EACA,aAAA,EAAA,yCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,gBAAA;EACA,2CAAA;EACA,2CAAA;EACA,kBAAA;EACA,eAAA,EAAA,+CAAA;EACA,QAAA;AADF;;AAIE;EACE;IACE,uBAAA,EAAA,uCAAA;IACA,eAAA,EAAA,0CAAA;EADJ;AACF;AAIE;EACE;IACE,uBAAA,EAAA,uCAAA;IACA,cAAA,EAAA,kDAAA;EAFJ;AACF;AAKE;EACE,wCAAA;AAHJ;;AAOE;EACE,aAAA;EACA,mBAAA;EAEA,mBAAA;AALJ;;AAQE;EACE,gCAAA;EACA,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AALJ;;AAQE;EACE,gCAAA;EACA,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,0BAAA;AALJ;;AAQE;EACE;IACE,eAAA;EALJ;AACF;AASE;EACE;IACE,eAAA;EAPJ;AACF;AAcE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,eAAA;AAZJ;;AAeE;EACE,UAAA,EAAA,2BAAA;EACA,gBAAA;EACA,2CAAA;EACA,kBAAA;EACA,2CAAA;EACA,YAAA;AAZJ;;AAeE;EACE,uBAAA;AAZJ","sourcesContent":[".gradient-text {\n    font-size: 35px;\n    font-weight: 700;\n    font-family: 'Graphik';\n    background: linear-gradient(to right, rgba(246, 106, 75, 1) 0%, rgba(246, 106, 75, 1) 30%, rgba(162, 74, 231, 1) 60%, rgba(72, 89, 243, 1) 100%);\n    -webkit-background-clip: text;\n    background-clip: text;\n    color: transparent;\n    text-align: center;\n  }\n  \n  .description {\n    color: rgba(255, 255, 255, 0.64);\n    font-family: 'Graphik';\n    font-size: 15px;\n    text-align: center;\n    margin-top: 10px;\n  }\n  \n\n  @media (max-width: 768px) {\n    .gradient-text {\n      font-size: 28px;\n    }\n  }\n  \n  .question-box {\n    margin-left: 25%;\n  }\n  \n  .box-home {\n    width: calc(15% - 10px); /* Adjusted to accommodate margin and padding */\n  margin: 5px;\n  padding: 10px; /* Increased padding for better spacing */\n  display: flex;\n  flex-direction: column;\n  cursor: pointer;\n  color: rgba(255, 255, 255, 0.86);\n  text-align: left;\n  background-color: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 5px;\n  font-size: 10px; /* Increased font size for better readability */\n  gap: 5px;\n  }\n\n  @media (max-width: 768px) {\n    .box-home {\n      width: calc(25% - 10px); /* Adjusted width for smaller screens */\n      font-size: 10px; /* Reduced font size for smaller screens */\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .box-home {\n      width: calc(50% - 10px); /* Adjusted width for smaller screens */\n      font-size: 8px; /* Further reduced font size for smaller screens */\n    }\n  }\n  \n  .box.selected {\n    background-color: rgba(161, 0, 255, 0.2);\n  }\n  \n  \n  .ask-section {\n    display: flex;\n    flex-direction: row;\n    // justify-content: space-between;\n    align-items: center;\n  }\n  \n  .ask-text {\n    color: rgba(255, 255, 255, 0.32);\n    font-family: 'Graphik', sans-serif;\n    font-size: 12px;\n    text-align: center;\n    margin: 20px 0px;\n  }\n\n  .ask-this {\n    color: rgba(255, 255, 255, 0.32);\n    font-family: 'Graphik', sans-serif;\n    font-size: 12px;\n    text-align: center;\n    text-decoration: underline;\n  }\n  \n  @media (max-width: 768px) {\n    .ask-text {\n      font-size: 14px;\n    //   margin-top: 8px;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .ask-text {\n      font-size: 13px;\n    //   margin-top: 6px;\n    }\n  }\n\n \n  \n  \n  .box_qest {\n    display: flex;\n    flex-wrap: wrap; \n    justify-content: center;\n    margin-top: 5px;\n  }\n\n  .vector-image {\n    width: 15%; /* Adjust width as needed */\n    margin-top: 20px;\n    background-color: rgba(255, 255, 255, 0.06);\n    border-radius: 5px;\n    border: 1px solid rgba(255, 255, 255, 0.06);\n    padding: 3px;\n  }\n\n  .box-home.selected {\n    border: 1px solid white;\n  }\n\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
